var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-food-table-expand-btn"},[_c('span',{staticClass:"order-food-table-expand-btn__icon",class:[_vm.disabled? 'is-disabled' : ''],on:{"click":function($event){!_vm.disabled && _vm.$emit('icon-click')}}},[_c('i',{class:_vm.isExpand ? 'el-icon-caret-bottom' : 'el-icon-caret-right'})]),_c('span',[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }